export const PAYMENT_STRINGS = {
    SEARCH_PLACEHOLDER: "Search by Date, CustomerId, or Customer",
    ADD_PAYMENT: "Add Payment",
    DATE: "Date",
    TYPE: "Type",
    CUSTOMER_ID: "CustomerId",
    CUSTOMER: "Customer",
    CURRENCY: "Currency",
    AMOUNT: "Amount",
    PAYMENT_METHOD: "Payment Method",
    NOT_AVAILABLE: "-",
    NO_PAYMENTS: "No payments found",
    TAKE_PAYMENT_NOW: "Take Payment Now",
    SCHEDULE_PAYMENT: "Schedule Payment",
    SEARCH_BY: "Search by",
    SEARCH_CUSTOMER_ID_PLACEHOLDER: "Search by Customer ID",
    SEARCH_LAST_NAME_PLACEHOLDER: "Search by Last Name",
    SEARCH_BUTTON: "Search",
    ADD_PAYMENT_TITLE: "Add Payment",
    NO_RECORDS_FOUND: "No records found.",
    CONFIRM_PAYMENT_TITLE: "Take Payment",
    SCHEDULE_PAYMENT_TITLE: "Schedule Payment",
    CONFIRM_NOW_MESSAGE: "Enter the payment amount to charge the selected customer.",
    CONFIRM_SCHEDULE_MESSAGE: "Pick the date to schedule the payment for the selected customer.",
    AMOUNT_LABEL: "Amount (USD)",
    SUBMIT: "Submit",
    CANCEL: "Cancel",
    SELECTED_CUSTOMER_ID: "Selected customer Id:",
    PAYMENT_DATE: "Payment Date",
};

export const PAYMENT_ERRORS = {
    FETCH_PAYMENTS_ERROR: "Error fetching payments",
    FETCH_PROMISES_ERROR: "Error fetching promises",
    ENTER_VALID_AMOUNT: "Enter a valid amount greater than 0",
    SELECT_DATE: "Please select a date",
    SEARCH_EMPTY: "Please enter search text.",
    SEARCH_FAILED: "Search failed. Please try again.",
    OPERATION_FAILED: "Operation failed",
};

export const PAYMENT_LABELS = {
    FIRST_NAME: "First Name",
    LAST_NAME: "Last Name",
    EMAIL: "Email",
};

// Field keys used for sorting and identifying properties on payment objects
export const PAYMENT_FIELDS = {
    PAYMENT_DATE: 'paymentDate',
    PAYMENT_TYPE: 'paymentType',
    CUSTOMER_ID: 'customerId',
    CUSTOMER_NAME: 'customerName',
    CURRENCY: 'currency',
    PAYMENT_AMOUNT: 'paymentAmount',
    PAYMENT_METHOD: 'paymentMethod',
};


